module.exports = __webpack_public_path__ + "static/media/newsletter-december-2021-1.7d1dc04c.jpg";